import styled from 'styled-components';

export const Subtitle = styled.p`
  margin: 0 0 1.25rem;
  color: #6b6f77;
  font-size: 14px;
`;

export const InsurerCard = styled.div`
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;

  & + & {
    margin-top: 12px;
  }
`;

export const InsurerName = styled.div`
  padding: 10px 16px;
  background-color: #f7f5fb;
  border-bottom: 1px solid #e4e4e7;
  color: #59249b;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

export const FileRow = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background-color: #ffffff;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.15s ease;

  & + & {
    border-top: 1px solid #f0f0f2;
  }

  &:hover:not(:disabled) {
    background-color: #faf8fd;
  }

  &:hover:not(:disabled) .download-icon {
    color: #854ee0;
  }

  &:disabled {
    cursor: progress;
  }

  &:focus-visible {
    outline: 2px solid #854ee0;
    outline-offset: -2px;
  }
`;

export const FileIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #e8f0fc;
  color: #2b62c4;

  &.pdf {
    background-color: #fdecec;
    color: #d93025;
  }

  i.icon {
    margin: 0;
    font-size: 18px;
  }
`;

export const FileInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileTitle = styled.div`
  color: #2b313c;
  font-size: 14px;
  font-weight: 600;
`;

export const FileMeta = styled.div`
  margin-top: 2px;
  color: #8a8f98;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DownloadSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  color: #a1a5ad;

  i.icon {
    margin: 0;
    transition: color 0.15s ease;
  }
`;
